"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBProductHomePositive = function SvgBProductHomePositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M30.107 46.487a2.107 2.107 0 01-2.108-2.107v-7.537a2.107 2.107 0 014.215 0v7.537a2.107 2.107 0 01-2.107 2.107z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M30.107 36.33a8.212 8.212 0 01-5.62-2.191 2.107 2.107 0 112.887-3.07 4.095 4.095 0 002.768 1.047c2.05 0 3.723-1.405 3.723-3.147 0-1.869-1.96-3-3.899-3.161a10.066 10.066 0 01-2.74-.583c-3.097-1.25-5.022-3.843-5.022-6.765 0-4.102 3.561-7.404 7.938-7.404a8.24 8.24 0 015.549 2.108 2.107 2.107 0 01-2.81 3.126 4.018 4.018 0 00-2.718-1.005c-2.051 0-3.723 1.405-3.723 3.147 0 1.742 1.763 2.641 2.36 2.88.491.162 1.001.26 1.517.295 4.496.372 7.727 3.463 7.727 7.355 0 4.053-3.561 7.368-7.937 7.368z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M30.107 47.415c-13.094 0-23.708-10.614-23.708-23.708C6.4 10.614 17.013 0 30.107 0c1.163 0 2.107.943 2.107 2.107v8.78a2.107 2.107 0 11-4.215 0v-6.56c-9.588 1.06-16.956 8.98-17.323 18.62-.367 9.64 6.378 18.096 15.858 19.882 9.48 1.787 18.84-3.635 22.006-12.747 3.167-9.112-.813-19.17-9.358-23.648a2.107 2.107 0 111.96-3.73 23.707 23.707 0 01-11.035 44.71zM138.458 73.946H22.098a2.107 2.107 0 110-4.215h116.36a2.107 2.107 0 110 4.215z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M46.136 103.828H31.385a4.847 4.847 0 01-4.84-4.84v-11.12a4.847 4.847 0 014.84-4.84h7.495a2.107 2.107 0 110 4.215h-7.495a.625.625 0 00-.625.625v11.12c0 .345.28.625.625.625h14.751a.618.618 0 00.443-.183.604.604 0 00.182-.442V85.136a2.107 2.107 0 114.215 0v13.852a4.833 4.833 0 01-4.84 4.84z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M140.958 73.946h-9.461a2.107 2.107 0 010-4.215h4.994L98.559 42.4a26.412 26.412 0 00-15.517-5.001H75.12a2.107 2.107 0 110-4.215h7.91a30.585 30.585 0 0117.975 5.795l41.591 29.945a2.775 2.775 0 01-1.623 5.023h-.014z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M128.16 127.05h-16.472a5.486 5.486 0 01-5.486-5.486V88.388c0-.66-.535-1.194-1.194-1.194H91.746c-.317-.001-.62.126-.843.351-.224.223-.35.526-.352.843v33.176a5.493 5.493 0 01-5.486 5.486H65.172a2.107 2.107 0 110-4.214h19.893c.703 0 1.272-.57 1.272-1.272V88.388a5.409 5.409 0 015.409-5.409h13.283a5.416 5.416 0 015.408 5.409v33.176c0 .702.57 1.272 1.272 1.272h16.451c.679 0 1.23-.55 1.23-1.23V71.838a2.107 2.107 0 114.214 0v49.768a5.45 5.45 0 01-5.444 5.444z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M55.247 127.05H15.454a5.45 5.45 0 01-5.444-5.444V73.94H2.732a2.725 2.725 0 01-1.559-4.967l.393-.273 40.812-29.643a30.57 30.57 0 0118.08-5.873 6.82 6.82 0 016.815 6.814v75.034a2.107 2.107 0 01-4.215 0V39.997a2.599 2.599 0 00-2.6-2.6 26.39 26.39 0 00-15.607 5.065L7.326 69.724h4.798c1.164 0 2.107.944 2.107 2.107v49.775a1.23 1.23 0 001.223 1.23h39.793a2.107 2.107 0 110 4.214z",
    fill: "#285"
  })));
};

var _default = SvgBProductHomePositive;
exports["default"] = _default;